import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MicrosoftProfile } from "../models/MicrosoftProfile";
import { ScheduleItem } from "../models/ScheduleItem";
import { Dispatch } from "../models/Dispatch";

@Injectable({
    providedIn: 'root'
})
export class MessageService {

    constructor(private http: HttpClient) {

    }

    sendQuestionMail(formData, schedule: ScheduleItem, dispatch: Dispatch): Observable<boolean> {
        let apiUrl = 'api/message/sendQuestionMail/';
        const email = {
            email: formData,
            schedule: schedule,
            dispatch: dispatch
        }
        return this.http.post<boolean>(apiUrl, email);
    }

    sendEmailAndTextMessage(messageInfo : any): Observable<string> {
        return this.http.post<string>('api/Message/sendemailinalerttruckerform', messageInfo);
    }

}